import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var WebcamService = /** @class */ (function () {
    function WebcamService(_http, _errorHandler) {
        this._http = _http;
        this._errorHandler = _errorHandler;
    }
    /**
     * updates specified entity via api
     * @param {number} airportID
     * @param {Webcam} webcam
     * @return {Promise<any>}
     */
    WebcamService.prototype.putWebcam = function (airportID, webcam) {
        var URL = environment.airportsApiUrl + "/airports/" + airportID + "/webcam/" + webcam.webcamId;
        try {
            var BODY = this._getWebcamJSON(webcam);
            return this._http.put(URL, BODY).toPromise();
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    /**
     * adds specified entity via api
     * @param {number} airportID
     * @param {Webcam} webcam
     * @return {Promise<any>}
     */
    WebcamService.prototype.postWebcam = function (airportID, webcam) {
        var URL = environment.airportsApiUrl + "/airports/" + airportID + "/webcam/";
        try {
            var BODY = this._getWebcamJSON(webcam);
            return this._http.post(URL, BODY).toPromise();
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    /**
     * deletes specified entity via api
     * @param {number} airportID
     * @param {number} webcamID
     * @return {Promise<any>}
     */
    WebcamService.prototype.deleteWebcam = function (airportID, webcamID) {
        var URL = environment.airportsApiUrl + "/airports/" + airportID + "/webcam/" + webcamID;
        try {
            return this._http.delete(URL).toPromise();
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    /**
     * converts entity to json obj
     * @param {Webcam} webcam
     * @return {any}
     * @private
     */
    WebcamService.prototype._getWebcamJSON = function (webcam) {
        return {
            name: webcam.name,
            site: webcam.site,
            url: webcam.url,
            direction: webcam.direction,
            operatedBy: webcam.operatedBy
        };
    };
    WebcamService.ngInjectableDef = i0.defineInjectable({ factory: function WebcamService_Factory() { return new WebcamService(i0.inject(i1.HttpClient), i0.inject(i0.ErrorHandler)); }, token: WebcamService, providedIn: "root" });
    return WebcamService;
}());
export { WebcamService };
